import {
  MyCardsLayout as MyCardsLayoutComponent,
  loader,
} from '#src/layouts/my-cards/MyCardsLayout/index.tsx';

import type { LayoutParams } from './__generated__/routeParams.ts';

export { loader };
const MyCardsLayout = () => {
  return <MyCardsLayoutComponent<LayoutParams> />;
};

export default MyCardsLayout;
